import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GlobalConstants } from '../../../../app/common/constants/global.constant';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { first } from 'rxjs/internal/operators/first';
import { Subject } from 'rxjs/internal/Subject';
import { DevicesService } from '../../../../app/core/routing/services/devices/devices.service';
import { DevicesConstants } from '../../../../app/core/routing/services/devices/constants/devices.constants';
import { Utils } from '../../../common/utils/utils';
import { AppGlobal } from 'src/app/core/state/app-global';
import { User } from '../../account/login/_models/user.model';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';
import { CommonService } from '../../../common/services/common.service';
import { CreateProfileService } from '../../../../app/core/routing/services/profile/create-profile.service';

@Component({
  selector: 'iposcen-device-settings',
  templateUrl: './device-settings.component.html',
  styleUrls: ['./device-settings.component.scss']
})
export class DeviceSettingsComponent implements OnInit, OnDestroy {
  passwordsLabel = DevicesConstants.DEVICE_PASSWORDS;
  buttonHeadingLabel = DevicesConstants.DEVICE_CUSTOMIZABLE_BUTTON;
  idleExperience = DevicesConstants.DEVICE_IDLE_EXPERIENCE;
  buttonAnimation: boolean;
  buttonFunction: string;
  statusAnimation: string;
  buttonCopy: string;
  selectedIdleTime: number;
  idleDisplay: string;
  settings: any;
  getInputCopy: string;
  isAttractorLoopRadionBtn: boolean;
  idleDisplayValue: string;
  isincreasePromotionRotation: boolean;
  attractLoopData;
  isRetailerId;
  selectedAttractLoopId: string;
  idleTimeValue: string;
  buttonEnabel;
  isdefault: boolean;
  websiteData = '';
  isWebsiteDataValid = true;
  customButton = '';
  buttonEnabeled: boolean;
  sendButton: boolean;
  emailValidationMsg: string = GlobalConstants.EMAIL_VALIDATION_MSG;
  buttonCopyPlaceHolder = DevicesConstants.ENTER_BUTTON_COPY;
  websiteUrlPlaceHolder = DevicesConstants.ENTER_URL;
  openModalPopup = false;
  successMessage = '';
  description = '';
  send: any;
  retailerConfig: any;
  isButtonCopyInputEnabel;
  userRole: string;
  isAttractLoopRecordFound = false;
  @ViewChild('attractLoopModal') attractLoopModal: ElementRef;
  @ViewChild('inputbutton') inputbutton: ElementRef;
  @ViewChild('profileChangePasswordModal') profileChangePasswordModal: ElementRef;
  private ngUnsubscribe = new Subject<boolean>();
  userInfo: any;
  isNonConnectedUser: boolean;
  showRetailGif = false;
  retailerId: string;
  globalconst = GlobalConstants;
  retailerUserId = sessionStorage.getItem('retailerId');
  constructor(
    public deviceSettingService: DevicesService, 
    private appGlobal: AppGlobal,
    private googleAnalyticsService: GoogleAnalyticsService,
    private cmnService: CommonService,
    private createProfSer: CreateProfileService
  ) { }

  ngOnInit(): void {
    this.isRetailerId = sessionStorage.getItem('retailerId') !== 'undefined';
    this.buttonEnabel = true;
    this.settings = {};
    this.getInputCopy = '';
    this.isAttractorLoopRadionBtn = false;
    this.isincreasePromotionRotation = false;
    this.idleTimeValue = GlobalConstants.IDLE_TIME_VALUE;
    this.buttonFunction = DevicesConstants.DEVICE_SPECIFICATION;
    this.buttonAnimation = false;
    this.buttonCopy = DevicesConstants.DEVICE_EXPLORE_THIS_PC;
    this.statusAnimation = GlobalConstants.DISABLED;
    this.selectedIdleTime = 120;
    this.idleDisplayValue = GlobalConstants.FACT_TAG_ROTATION_VALUE;
    this.isdefault = true;
    this.sendButton = false;
    this.isButtonCopyInputEnabel = true;
    this.retailerId = sessionStorage.getItem(GlobalConstants.RETAILER_ID);
    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((userAccount: User) => {
        this.userRole = userAccount.role;
        if(this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ){
          this.retailerConfig = JSON.parse(userAccount?.configurations);
        }
        this.userInfo = { ...userAccount };
        this.isNonConnectedUser = this.userInfo.role === GlobalConstants.NON_CONNECTED_USER ? true : false;
      });
      this.cmnService.getRetailGifValue
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        if(data) {
          this.showRetailGif = true;
          setTimeout(() => {
            this.showRetailGif = false; 
            this.cmnService.setRetailGifValue(false);
          }, 1000);
        }
      });
  }

  openModal(modal: any) { modal.open(); }

  closeModal(modal: any) { modal.close(); }

  openChangePasswordModal(type: string) {

    this.openModals(this.profileChangePasswordModal, type);
  }

  openModals(modal: any, type: string) { modal.open(type); }

  closeModals(modal: any) { modal.close(); }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  isPromotionRotation(data) {
    this.isincreasePromotionRotation = data.currentTarget.checked;
  }
  openAttractLoopModal() {
    this.openModal(this.attractLoopModal);
  }
  getAttractLoopRecordCount(data) {
    if (data > 0) this.isAttractLoopRecordFound = true;
  }
  getSelectedAttractLoopData(data) {
    if(data?.status){
      this.attractLoopData = {
        attractLoopId: data?.id,
        showOnDevice: true
      };
      this.buttonEnabel = true;
    } else {
      this.attractLoopData = {
        showOnDevice: false
      };
      this.buttonEnabel = false;
    }
  }
  checkInput() {
    this.sendButton = (this.websiteData === '' || this.customButton === '');
  }
  customizableButton(data, element) {
    if (element === 'buttonFunc1') {
      this.buttonFunction = data;
      this.isdefault = true;
      this.sendButton = false;

    } else if (element === 'buttonFunc2') {
      this.buttonFunction = data;
      this.isdefault = false;
      this.sendButton = true;

    } else if (element === 'status') {
      this.buttonAnimation = data.currentTarget.checked;
      this.statusAnimation = this.buttonAnimation ? GlobalConstants.ENABLED : GlobalConstants.DISABLED;
    } else if (element === 'buttonCopyInput' && this.inputbutton.nativeElement.checked) {
      this.buttonCopy = data;
      this.isButtonCopyInputEnabel = false;
    } else if (element === 'buttonCopy') {
      this.buttonCopy = data;
      this.isButtonCopyInputEnabel = true;
    } else if (element === 'time') {
      this.selectedIdleTime = +data.target.value;
    } else if (element === 'factTag') {
      this.idleDisplayValue = data;
      this.isAttractorLoopRadionBtn = false;
      this.buttonEnabel = true;
    } else if (element === 'attractloop') {
      this.isincreasePromotionRotation = false;
      this.idleDisplayValue = data;
      this.isAttractorLoopRadionBtn = true;
      this.buttonEnabel = false;
    }
  }

  async updateCustomizableButton() {
    const payload = {
      animationButton: this.buttonAnimation,
      buttonFunctionality: {}
    };
    if (this.buttonFunction === DevicesConstants.DEVICE_SPECIFICATION) {
      if (this.buttonCopy === DevicesConstants.DEVICE_EXPLORE_THIS_PC) {
        payload.buttonFunctionality = {
          type: DevicesConstants.DEVICE_SPECIFICATION,
          url: '',
          customButtonCopyText: DevicesConstants.DEVICE_EXPLORE_THIS_PC
        };
      } else {
        payload.buttonFunctionality = {
          type: `${DevicesConstants.DEVICE_SPECIFICATION}`,
          url: '',
          customButtonCopyText: this.buttonCopy
        };
      }
    } else {
      payload.buttonFunctionality = {
        type: DevicesConstants.URL,
        url: this.websiteData,
        customButtonCopyText: this.customButton
      };
    }
    let updatedRetailData:any = await this.fetchRetailHQData();
    if(updatedRetailData?.retailer?.configurations){
      this.retailerConfig = JSON.parse(updatedRetailData?.retailer?.configurations);
    }
    let settingsPayload:any = { 
      customizableButton: payload, 
      otherSettings:this.configData(false)
    };
    if(
      (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) && 
      this.retailerConfig?.displayDeviceRetailerId?.length
    ){
      settingsPayload.otherSettings.displayDeviceRetailerId = this.retailerConfig?.displayDeviceRetailerId
    }
    const send = { 
      settings: JSON.stringify(settingsPayload)
    };
    this.deviceSettingService.deviceSettingPatchReq(JSON.stringify(send), this.retailerUserId)
      .pipe(first())
      .subscribe(response => {
      });
    this.openModalPopup = !this.openModalPopup;
    this.successMessage = DevicesConstants.DEVICE_UPDATE_SAVED;
    this.description = DevicesConstants.SUCCESS_CUSTOMIZABLE_DESC;
  }

  async sendAttractLoop() {
    let updatedRetailData:any = await this.fetchRetailHQData();
    if(updatedRetailData?.retailer?.configurations){
      this.retailerConfig = JSON.parse(updatedRetailData?.retailer?.configurations);
    }
    const payload:any = {
      idleExperience: {
        TimeUntilIdle: this.selectedIdleTime,
        IdleDisplay: this.idleDisplayValue
      },
      otherSettings: this.configData(true)
    };
    if(
      (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) && 
      this.retailerConfig?.displayDeviceRetailerId?.length
    ){
      payload.otherSettings.displayDeviceRetailerId = this.retailerConfig?.displayDeviceRetailerId
    }
    this.send = { settings: JSON.stringify(payload) };
    if (this.isAttractorLoopRadionBtn) {
      this.deviceSettingService.deviceSettingPatchReq({ attractLoop: this.attractLoopData }, this.retailerUserId)
        .pipe(first())
        .subscribe(response => {
        });
    }
    setTimeout(() => {
      this.deviceSettingService.deviceSettingPatchReq(this.send,this.retailerUserId)
      .pipe(first())
      .subscribe(response => {
      });
    }, 1000);

    // popup opening
    this.openModalPopup = !this.openModalPopup;
    this.successMessage = DevicesConstants.DEVICE_UPDATE_SAVED;
    this.description = DevicesConstants.SUCCESS_IDLE_DESC;
    this.sendGAForIdleSettings(this.idleDisplayValue);
  }
  closePopup() {
    this.openModalPopup = !this.openModalPopup;

  }

  validateURL(event) {
    this.isWebsiteDataValid = Utils.validateUrl(event.target.value);
    this.checkInput();
  }
  //IIt2-5334
  fetchRetailHQData(){
    return new Promise((resolve,reject) => {
      if (Utils.checkRole(this.userRole)) {
        this.createProfSer.getUserRoleData('userId', this.retailerId)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(data => {
            resolve(data);
          })
      }else{
        resolve({});
      }
    })
  }
  configData(isAttractorLoop){
    let jsonData = { 
      isBrandColorEnabled : Utils.checkRole(this.userRole) ? 
      (this.retailerConfig?.bandColor !== undefined ? this.retailerConfig?.bandColor : false) :
      false, 
      brandColor : Utils.checkRole(this.userRole) ? 
        (this.retailerConfig?.bgcolor ? this.retailerConfig?.bgcolor : "") : "",
      enable3DMarkFeature : Utils.checkRole(this.userRole) ? 
        (this.retailerConfig?.enable3DMarkFeature !== undefined ? this.retailerConfig?.enable3DMarkFeature : false) :
        false,
      enableMobileSocket:GlobalConstants.SOCKET_DEFAULT_VALUE,
      pollFrequency:Utils.checkRole(this.userRole) ? 
      (this.retailerConfig?.pollFrequency ? this.retailerConfig?.pollFrequency : GlobalConstants.POLL_FREQ_DEFULT_VALUE) :
      GlobalConstants.POLL_FREQ_DEFULT_VALUE
    };
    if(isAttractorLoop){
      jsonData['increasePromotionRotation'] = this.isincreasePromotionRotation;
    }
    return jsonData;
  }

  sendGAForIdleSettings(idleDisplay: string) {
    this.googleAnalyticsService.pushUpdateIdle();
    this.googleAnalyticsService.idleExperienceOption(idleDisplay);
    if (this.isincreasePromotionRotation) {
      this.googleAnalyticsService.increasedPromoRotation();
    }
  }
}
